module.exports = __webpack_public_path__ + "static/think-like-a-doctor-pdf-cover-image-d2033eee4675992bc5078af876fc80b3.png";